import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { TileNavigation } from '../components/molecules/TileNavigation';
import { useStore } from '../store';


const useStyles = makeStyles((theme) => ({

    welcomeText: {
        fontSize: '2.4rem',
        wordBreak: "break-word", // breaks long string on mobile
        whiteSpace: "normal", // To allow in wraping 
        textOverflow: 'clip',
        [theme.breakpoints.down('sm')]: { fontSize: '1.2rem', },
        color: '#2c397f',
    },
}));



const tiles: Array<{ section: string, services: Array<{ title: string, logo: string, to: string, detail: string }> }> = [
    {
        section: "Personal Information (ব্যক্তিগত তথ্য)",
        services: [
            { title: "Profile Details (ব্যক্তিগত পরিচিতি)", logo: "assets/img/profile-details.png", to: "/profile-details", detail: "profile-details" },
            { title: "PPO Details (পেনশন পেমেন্ট অর্ডারের বিবরণ)", logo: "assets/img/ppo.png", to: "/ppo", detail: "ppo-details" },
            { title: "Life Certificates (জীবনপ্রমাণ পত্র)", logo: "assets/img/life-certificate.png", to: "/life-certificate", detail: "life-certificate" },

        ]
    },
    {
        section: "Identity Card (পরিচয়পত্র)",
        services: [
            { title: "Application Form for Pensioner's Identity Card (পেনশনভোগীর পরিচয়পত্রের জন্য আবেদনপত্র)", logo: "assets/img/id-card-apply.png", to: "/aplication-form-pensioners-identity-card", detail: "" },
            { title: "Upload Attested Application Form PDF (স্বাক্ষরিত এবং সিলমোহরযুক্ত আবেদনপত্রের পিডিএফ অনলাইনে আপলোড করুন)", logo: "assets/img/id-card-upload-form.png", to: "/upload-attested-appl-form", detail: "" },
            { title: "Know Application Status / Download Identity Card (আবেদনপত্রের বর্তমান স্থীতি জানুন / পরিচয়পত্র ডাউনলোড করুন)", logo: "assets/img/download-id-card-1.png", to: "/track-pensioners-identity-card", detail: "" },

        ]
    },
    {
        section: "Pensioner Benefits and Payments (পেনশনভোগীর আর্থিক সুবিধা ও অর্থপ্রদান)",
        services: [
            { title: "Monthly Pension Statement (পেনশন প্রদানের মাসিক বিবরণ)", logo: "assets/img/monthy-payment-statement.png", to: "/monthly-pay-statement", detail: "monthly-pay-statement" },
            { title: "Annual Pension Statement (পেনশন প্রদানের বার্ষিক বিবরণ)", logo: "assets/img/annual-payment-statement.png", to: "/annual-statement", detail: "annual-statement" },
            { title: "Medical Insurance Option (চিকিৎসা বীমা বিকল্প)", logo: "assets/img/medical-insurance.png", to: "https://emedoption.wbsedcl.in/auth/login/", detail: "medical-insurance" },

        ]
    },
    {
        section: "Employee Benefits and Payments (কর্মরত অবস্থায় প্রাপ্য সুবিধা ও অর্থপ্রদান)",
        services: [
            { title: "Monthly Payslip (কর্মকালীন মাসিক বেতন বিবরণী)", logo: "assets/img/monthy-payslip-1.png", to: "/payslip", detail: "emp-payslip" },
            { title: "Annual PF Statement (বার্ষিক পিএফ সঞ্চয় বিবরণী)", logo: "assets/img/annual-pf-statement-3.png", to: "/emp-annual-statement", detail: "emp-annual-statement" },
            { title: "Terminal Benefit Statement (অবসরকালীন সুবিধা বিবৃতি)", logo: "assets/img/terminal-benefits-statement.png", to: "/terminal-benefit-statement", detail: "terminal-benefit-statement" },

        ]
    },
    {
        section: "Income Tax (আয়কর)",
        services: [
            // { title: "Income Tax Declaration (আয়কর ঘোষণা)", logo: "assets/img/wbsedcl-logo.png", to: "/it-declaration", detail: "Details..." },
            { title: "Download Form 16 (ফর্ম 16 ডাউনলোড করুন)", logo: "assets/img/download-form16.png", to: "/form16", detail: "form16" },
            { title: "Opt Tax Regime (করব্যবস্থা বেছে নিন)", logo: "assets/img/opt-tax-regime.png", to: "/opt-tax-regime", detail: "opt-tax-regime" },
        ]
    },

];


type DashboardPageProps = {
}

export const DashboardPage = observer<DashboardPageProps>((props) => {
    const store = useStore();
    const classes = useStyles();
    const [optTaxRegimeEligible, setOptTaxRegimeEligible] = useState(false);
    const [optTaxRegimeBegin, setOptTaxRegimeBegin] = useState(false);
    const titleCase = (text: string) => {
        const str = text.toLowerCase().split(' ');
        for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        return str.join(' ');
    }

    useEffect(() => {
        fetchOptTaxRegimeEligiblity()
    }, []);

    // const fetchOptTaxRegimeEligiblity = async () => {
    //     axios.get<any>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONEROPTTAXREGIMEWS/FetchCutOffDate`, {
    //        headers: {
    //            'Content-Type': 'application/json',
    //        }
    //     })
    //         // axios.get<any>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONEROPTTAXREGIMEWS/FetchCutOffDate`, {
    //         //     headers: {
    //         //         'Content-Type': 'application/json',
    //         //     }
    //         // })
    //         .then(
    //             ({ data: resp }) => {
    //                 console.log(resp, "resp", resp && resp?.Cutoff_Date);
    //                 if (resp && resp?.Cutoff_Date) {
    //                     let Cutoff_Date = moment(resp?.Cutoff_Date, 'DD.MM.YYYY');
    //                     let today = moment();
    //                     console.log(today, Cutoff_Date, today.diff(Cutoff_Date, "days"));
    //                     if (today.diff(Cutoff_Date, "days") > 0) {
    //                    ia-portal     setOptTaxRegimeEligible(false);
    //                     }
    //                     else {
    //                         setOptTaxRegimeEligible(true);
    //                     }
    //                 }
    //                 else {
    //                     setOptTaxRegimeEligible(false);
    //                 }
    //             }
    //         )
    //         .catch((e) => {
    //             setOptTaxRegimeEligible(false);
    //         })
    // }

    const fetchOptTaxRegimeEligiblity = async () => {
        try {
            let start_date = Number(process.env.REACT_APP_TAX_REGIME_START_DATE);
            let cutoff_date = Number(process.env.REACT_APP_TAX_REGIME_END_DATE);
            console.log("start_date:", start_date, "end_date: ", cutoff_date);
            let today = Number(moment(new Date()).format('YYYYMMDD'));
            console.log("Today :", today);
            if (today >= start_date && today <= cutoff_date) {
                setOptTaxRegimeBegin(true);
                setOptTaxRegimeEligible(true);
                console.log("S", "S");
            }
            else if (today >= start_date && today > cutoff_date) {
                setOptTaxRegimeBegin(true);
                setOptTaxRegimeEligible(false);
                console.log("S", "R");
            }
            else if (today < start_date) {
                setOptTaxRegimeBegin(false);
                setOptTaxRegimeEligible(false);
                console.log("R", "R");
            }
        }
        catch (e) {
            setOptTaxRegimeEligible(false);
            setOptTaxRegimeBegin(false);
            console.log("error");
        }
    }

    return (
        <AppShell>
            <Grid container spacing={3}
                direction="row"
                justify="space-around"
                alignItems="stretch"
                style={{backgroundColor: "#eaf8ff"}}>
                <Grid item xs={12}>
                    <Typography variant="h3" component="h3" className={classes.welcomeText}>
                        স্বাগত <b>{titleCase(store.auth.user?.name || '')}</b>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TileNavigation tiles={tiles} optTaxRegimeBegin={optTaxRegimeBegin} optTaxRegimeEligible={optTaxRegimeEligible} />
                </Grid>
            </Grid>
        </AppShell>
    )

})